import { router } from '@inertiajs/vue3'
import posthog from 'posthog-js'

export default {
  install(app) {
    const windowPosthog = typeof window !== 'undefined' ? window.posthog : null
    const apiKey = import.meta.env.VITE_POSTHOG_API_KEY
    const host = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'
    const uiHost = import.meta.env.VITE_POSTHOG_HOST

    const initConfig = {
      api_host: host,
      ...(uiHost ? { ui_host: uiHost } : {}),
      defaults: '2025-11-30',
      person_profiles: 'identified_only',
      // 页面浏览追踪
      capture_pageview: false, // 禁用自动追踪，改用 Inertia 路由监听
      capture_pageleave: true,
      // Session Recording - 录制用户会话
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true // 密码输入框打码
        }
      },
      // 自动捕获
      autocapture: true,
      // 性能监控
      capture_performance: true,
      // 本地存储
      persistence: 'localStorage+cookie',
      // Feature Flags 自动加载
      bootstrap: {},
      // 错误追踪
      capture_dead_clicks: true
    }

    if (!windowPosthog && apiKey) {
      posthog.init(apiKey, initConfig)
    }

    const client = windowPosthog || posthog
    if (windowPosthog || apiKey) {
      // 监听 Inertia 路由变化，手动追踪页面浏览
      router.on('navigate', (event) => {
        client.capture('$pageview', {
          $current_url: event.detail.page.url,
          page_component: event.detail.page.component
        })
      })
    }

    app.config.globalProperties.$posthog = client
    app.provide('posthog', client)
  }
}

export { posthog }
